import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const checkboxErrorFn = /* @__PURE__ */ createRecipe('checkbox-error', {}, [])

const checkboxErrorVariantMap = {}

const checkboxErrorVariantKeys = Object.keys(checkboxErrorVariantMap)

export const checkboxError = /* @__PURE__ */ Object.assign(memo(checkboxErrorFn.recipeFn), {
  __recipe__: true,
  __name__: 'checkboxError',
  __getCompoundVariantCss__: checkboxErrorFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: checkboxErrorVariantKeys,
  variantMap: checkboxErrorVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, checkboxErrorVariantKeys)
  },
  getVariantProps: checkboxErrorFn.getVariantProps,
})